import { useEffect } from "react"
import {
    Toast,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
    ToastProps,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

export function Toaster() {
    const { toasts, dismiss } = useToast()

    return (
        <ToastProvider>
            {toasts.map(function ({ id, title, description, action, ...props }) {
                return (
                    <ToastMessage
                        key={id}
                        id={id}
                        title={title}
                        description={description}
                        action={action}
                        dismiss={dismiss}
                        {...props}
                    />
                )
            })}
            <ToastViewport />
        </ToastProvider>
    )
}

interface ToastMessageProps extends Omit<ToastProps, "title" | "description"> {
    id: string
    title?: React.ReactNode
    description?: React.ReactNode
    action?: React.ReactNode
    dismiss: (id: string) => void
}

function ToastMessage({ id, title, description, action, dismiss, ...props }: ToastMessageProps) {
    useEffect(() => {
        const timer = setTimeout(() => {
            dismiss(id)
        }, 5000)

        return () => clearTimeout(timer)
    }, [id, dismiss])

    return (
        <Toast {...props} className="animate-in slide-in-from-top-full fade-in duration-300 data-[state=closed]:animate-out data-[state=closed]:fade-out-80">
            <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                    <ToastDescription>{description}</ToastDescription>
                )}
            </div>
            {action}
            <ToastClose onClick={() => dismiss(id)} />
        </Toast>
    )
}
